enum RealEstateStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description create RealEstate request.
   * @deprecated Use CreateRealEstateV3 instead
   */
  CreateRealEstate = "/v2/admin/realestates/create",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description create RealEstate request.
   */
  CreateRealEstateV3 = "/v3/admin/realestates",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description list RealEstate request.
   */
  ListRealEstate = "/v2/admin/realestates",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description referer RealEstate request.
   */
  RefererProperty = "/v2/admin/realestates/refer",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description referer RealEstate request.
   */
  SeoWithAi = "/v2/admin/realestates/seo-with-ai",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description report RealEstate request.
   */
  ReportProperty = "/v2/admin/realestates/report",
  // checkConflic
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description CheckConflict RealEstate request.
   */
  CheckConflict = "/v2/admin/realestates/check_conflicts",

  // solve conflict
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description SolveConflict RealEstate request.
   */
  SolveConflict = "/v2/admin/realestates/solveConflicts?_method=PUT",

  // send feedback
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description Send feedback for any fuctions.
   */
  SendFeedback = "/v2/admin/realestates/feedback",

  // get trust entities
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get trust entities.
   */
  GetTrustEntities = "/v2/trust-entities",

  // get trust entities
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description translate seo.
   */
  SeoTranslation = "/v2/admin/realestates/seo-translation",
  // get trust entities
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Draft property.
   */
  Draft = "/v2/admin/realestates/draft",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Upload image for property.
   */
  UploadImage = "/v2/admin/realestates/upload-image",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Upload document for property.
   */
  UploadDocument = "/v2/admin/realestates/upload-document",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description Upload document for property.
   */
  generateSeoWithChatGpt = "/v3/admin/realestates/ai-description"
  ,
  /**
   * @member {string}
   * @method post
   * @version 3.0
   * @description translate SEO v3 (JSON body)
   */
  TranslationV3 = "/v3/admin/realestates/translation"
}

const RealEstateDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates request
   */
  GetRealEstateFeatures: (realestate_type: number) =>
    `/v2/realestates/features/${realestate_type}`,

  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates request
   */
  DetailRealEstate: (id?: string) => `/v2/admin/realestates/${id}`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description update RealEstates request
   * @deprecated Use UpdateRealEstateV3 instead
   */
  UpdateRealEstate: (id?: string | number) =>
    `/v2/admin/realestates/update/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description update RealEstates request
   */
  UpdateRealEstateV3: (id?: string | number) =>
    `/v3/admin/realestates/${id}?_method=PUT`,

  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description delete RealEstates request
   */
  DeleteRealEstate: (id: string | number) =>
    `/v2/admin/realestates/delete/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description activate RealEstates request
   */
  ActivateRealEstate: (id: string | number) =>
    `/v2/admin/realestates/activate/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description activate RealEstates request
   */
  DropRealEstate: (id: string | number) =>
    `/v2/admin/realestates/drop/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method PUT
   * @version 1.0
   * @description last changes RealEstates request
   */
  LastChanges: (id: string | number) => `/v2/admin/realestates/${id}/changes`,

  // get conflict
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates conflict request
   */
  GetConflict: (id: string | number) => `/v2/admin/realestates/${id}/conflicts`,
  // get conflict
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates Advances request
   */
  getAdvanceData: (id: string | number) =>
    `/v2/admin/realestates/${id}/advance-data`,
  // get conflict
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates Advances request
   */
  approveDocument: () => `/v2/admin/realestates/validation-documents/approve`,
  // get conflict
  /**
   * @member {string}
   * @method GET
   * @version 1.0
   * @description list RealEstates Advances request
   */
  declineDocument: () => `/v2/admin/realestates/validation-documents/reject`,
  /**
   * @member {string}
   * @method POST
   * @version 1.0
   * @description Partial activate RealEstate request
   */
  partialActivateRealEstate: (id: string | number) =>
    `/v2/admin/realestates/${id}/restore-status?_method=PUT`,

  /**
   * @member {string}
   * @method POST
   * @version 3.0
   * @description Upload image for an existing RealEstate (edit mode).
   */
  UploadImageById: (id: string | number) => `/v3/admin/realestates/${id}/images`,

  /**
   * @member {string}
   * @method POST
   * @version 3.0
   * @description Upload document for an existing RealEstate (edit mode).
   */
  UploadDocumentById: (id: string | number) =>
    `/v3/admin/realestates/${id}/documents`,
  /**
   * @member {string}
   * @method DELETE
   * @version 3.0
   * @description Delete image for an existing RealEstate (edit mode).
   */
  DeleteImageById: (id: string | number, imageId: string | number) =>
    `/v3/admin/realestates/${id}/images/${imageId}`,

  /**
   * @member {string}
   * @method POST
   * @version 3.0
   * @description Send activation request email for a RealEstate.
   */
  ActivationRequest: (id: string | number) =>
    `/v3/admin/realestates/${id}/activation-request`
};

export const RealEstateEndpoints = {
  ...RealEstateDynamic,
  ...RealEstateStatic
};

export type RealEstateEndpoints = typeof RealEstateEndpoints;

// power by mouseinyl
